import { z } from "zod";
import { MemberRoleEnum } from "./member-role.js";
export const memberPermissionsSchema = z
    .object({
    bookings_view: z.boolean(),
    bookings_manage: z.boolean(),
    tenants_manage: z.boolean(),
    contracts_manage: z.boolean(),
    calendar_manage: z.boolean(),
    pricing_manage: z.boolean(),
    property_edit: z.boolean(),
    members_manage: z.boolean(),
})
    .strict();
export const MEMBER_PERMISSION_KEYS = [
    "bookings_view",
    "bookings_manage",
    "tenants_manage",
    "contracts_manage",
    "calendar_manage",
    "pricing_manage",
    "property_edit",
    "members_manage",
];
const NO_PERMISSIONS = {
    bookings_view: false,
    bookings_manage: false,
    tenants_manage: false,
    contracts_manage: false,
    calendar_manage: false,
    pricing_manage: false,
    property_edit: false,
    members_manage: false,
};
const VIEWER_PERMISSIONS = {
    ...NO_PERMISSIONS,
    bookings_view: true,
};
const MANAGER_PERMISSIONS = {
    bookings_view: true,
    bookings_manage: true,
    tenants_manage: false,
    contracts_manage: true,
    calendar_manage: true,
    pricing_manage: true,
    property_edit: false,
    members_manage: false,
};
const ADMIN_PERMISSIONS = {
    bookings_view: true,
    bookings_manage: true,
    tenants_manage: true,
    contracts_manage: true,
    calendar_manage: true,
    pricing_manage: true,
    property_edit: true,
    members_manage: false,
};
export function permissionsForRole(role) {
    switch (role) {
        case MemberRoleEnum.VIEWER:
            return { ...VIEWER_PERMISSIONS };
        case MemberRoleEnum.MANAGER:
            return { ...MANAGER_PERMISSIONS };
        case MemberRoleEnum.ADMIN:
            return { ...ADMIN_PERMISSIONS };
        default:
            return { ...NO_PERMISSIONS };
    }
}
